import '.c3{position:relative;}.ssr-plugin'
import '.a4{width:100%;}.ssr-plugin'
import '.ga{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.bn{align-items:flex-start;}.ssr-plugin'
import '.q{padding:2rem;}.ssr-plugin'
import '.db{background:var(--palette-white);}.ssr-plugin'
import '.ai{overflow:hidden;}.ssr-plugin'
import '.at{position:absolute;}.ssr-plugin'
import '.j2{top:50%;}.ssr-plugin'
import '.j3{right:1rem;}.ssr-plugin'
import '.j4{transform:translateY(-50%);}.ssr-plugin'
import '.j5{width:120px;}.ssr-plugin'
import '.j6{height:120px;}.ssr-plugin'
import '.j7{z-index:0;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.hp{z-index:1;}.ssr-plugin'
import '.a6{gap:0.5rem;}.ssr-plugin'
import '.j8{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="c3 a4 ga d e i bn q db ai"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="at j2 j3 j4 j5 j6 j7 d f i"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="c3 hp d e bn a6 j8"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
